import React from 'react';
export function GuaranteeSection() {
  return <section className="bg-warm-light py-16 md:py-20 px-4" data-id="element-133">
      <div className="max-w-3xl mx-auto text-center" data-id="element-134">
        {/* Shield icon */}
        <div className="inline-flex items-center justify-center w-20 h-20 bg-white rounded-full shadow-md mb-6 border-4 border-soft-gold" data-id="element-135">
          <span className="text-4xl" data-id="element-136">🛡️</span>
        </div>

        {/* Heading */}
        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-warm-hero mb-8 leading-tight" data-id="element-137">
          7-Day <span className="italic text-soft-gold" data-id="element-138">Risk-Free</span>{' '}
          Guarantee
        </h2>

        {/* Copy */}
        <div className="font-sans text-lg md:text-xl text-gray-800 space-y-4 max-w-xl mx-auto leading-relaxed" data-id="element-139">
          <p data-id="element-140">Try it for 7 days.</p>
          <p data-id="element-141">
            If it's not for you, we'll refund{' '}
            <span className="font-semibold" data-id="element-142">100% of your money.</span>
          </p>
          <p className="pt-2 font-semibold text-warm-hero" data-id="element-143">
            No stress. No risk. No awkward back-and-forth.
          </p>
        </div>
      </div>
    </section>;
}